import { TYPE_COMMANDE, TYPE_DEVIS } from '@/configuration/devisConf';
import { checkMontantAllEcheancierAuto }
  from '@/services/commande/echeancierFacturation/checkMontantEcheancierAuto';
import updateDatesAllEcheancierAuto
  from '@/services/commande/echeancierFacturation/updateDatesAllEcheancierAuto';

function findReferenceEchancier(referenceEcheancier, lignes) {
  let findLigne = false;
  lignes.forEach((ligne) => {
    if (ligne.referenceEcheancier === referenceEcheancier) findLigne = true;
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        if (ligneEnfant.referenceEcheancier === referenceEcheancier) findLigne = true;
      });
    }
  });
  return findLigne;
}

export default function deleteLignesEcheanciersInutiles(commande) {
  if (commande.type !== TYPE_COMMANDE && commande.type !== TYPE_DEVIS) return;
  const echeanciers = [];
  commande.echeanciers.forEach((echeancier) => {
    const findEchancier = findReferenceEchancier(
      echeancier.referenceEcheancier, commande.lignesCommande,
    );
    if (findEchancier) echeanciers.push(echeancier);
  });
  commande.echeanciers = echeanciers;
  checkMontantAllEcheancierAuto(commande);
  updateDatesAllEcheancierAuto(commande);
}
